export default __webpack_public_path__ + "static/media/offline.06b8a2f8.png";